import { getPremiumEssentialsSafe } from '@wix/premium-fed-sdk/@premium-essentials';
import { ModalsModule } from '../../ModalsExtensions';
import { urls } from '../../Navigation/urls';
import { StatusesModule } from './Statuses/StatusesModule';
import { entriConnectAction } from './entriConnectAction';
import { DomainsApiClient } from '@wix/domains-serverless-interface/react-kit';
import { fetchWithFallback } from '@wix/premium-fed-sdk/@apis-infra';
import { DomainSearchSuiteModule } from '../../../domainSearchSuite.module';
import { EntriFlowStatus } from '@wix/domains-serverless-interface';
export const actionStatuses = {
  connect: _ref => {
    let {
      domainName,
      msid,
      siteName,
      t,
      actionHandler,
      externalViewer,
      fullPage,
      autoInvoke
    } = _ref;
    return {
      action: async () => {
        if (!msid || !siteName) {
          actionHandler == null || actionHandler({
            result: EntriFlowStatus.manual,
            externalViewer,
            domainName,
            msid,
            siteName
          });
          return;
        }
        const result = await entriConnectAction({
          domainName,
          msid,
          siteName,
          fullPage,
          t
        });
        actionHandler == null || actionHandler({
          result: result.status,
          externalViewer,
          domainName,
          msid,
          siteName
        });
      },
      StatusComponent: StatusesModule.SDK.Components.DomainIsTaken,
      autoInvoke
    };
  },
  transfer: _ref2 => {
    let {
      domainName,
      msid,
      siteName,
      t,
      actionHandler,
      externalViewer,
      fullPage,
      autoInvoke
    } = _ref2;
    const essentials = getPremiumEssentialsSafe();
    const {
      httpClient
    } = essentials ?? {};
    const yearlyPrice = fetchWithFallback(DomainsApiClient.query.domainYearlyPrice({
      httpClient: httpClient,
      request: {
        domainName,
        isRenewal: false
      }
    }), {
      displayedPrice: undefined,
      amount: undefined,
      currency: undefined
    });
    const isPremiumDomain = fetchWithFallback(DomainsApiClient.query.isPremiumDomain({
      httpClient: httpClient,
      request: {
        domain: domainName
      }
    }), {
      isPremiumDomain: false
    });
    return {
      action: async () => {
        const {
          transfer
        } = ModalsModule.internals.domainsActionsModalsController;
        const {
          loaderModal
        } = ModalsModule.internals.domainsSharedModalsController;
        if (!msid || !siteName) {
          return;
        }
        loaderModal.show({});
        const {
          hasPermission
        } = await DomainsApiClient.query.getPurchasePermissions({
          httpClient: httpClient,
          request: {}
        });
        if (!hasPermission) {
          const result = await entriConnectAction({
            domainName,
            msid,
            siteName,
            fullPage,
            t
          });
          actionHandler == null || actionHandler({
            result: result.status,
            externalViewer,
            domainName
          });
          return;
        }
        await yearlyPrice;
        const {
          isPremiumDomain: isPremiumDomainResult
        } = await isPremiumDomain;
        await DomainsApiClient.query.listDisplayPrices({
          httpClient: httpClient,
          request: {
            domains: [{
              domain: domainName,
              premium: isPremiumDomainResult
            }]
          }
        });
        loaderModal.hide();
        transfer.show({
          primaryButtonOnClick: async action => {
            switch (action) {
              case 'connect':
                {
                  const result = await entriConnectAction({
                    domainName,
                    msid,
                    siteName,
                    fullPage,
                    t
                  });
                  actionHandler == null || actionHandler({
                    result: result.status,
                    externalViewer,
                    domainName
                  });
                  ModalsModule.internals.domainsActionsModalsController.transfer.hide();
                  break;
                }
              case 'transfer':
                {
                  const url = urls.transferInUrl({
                    domainName,
                    msid,
                    referralAdditionalInfo: 'gate-transfer-in'
                  });
                  ModalsModule.internals.domainsActionsModalsController.transfer.hide();
                  window.open(url, '_blank');
                  break;
                }
            }
          },
          domainName
        });
      },
      StatusComponent: StatusesModule.SDK.Components.DomainIsTaken,
      autoInvoke
    };
  },
  purchase: props => ({
    action: async () => {
      const {
        domainName,
        msid,
        siteName,
        actionHandler
      } = props;
      if (actionHandler) {
        await actionHandler({
          result: undefined,
          ...props
        });
        return;
      }
      if (!msid || !siteName) {
        return;
      }
      const viewMode = DomainSearchSuiteModule.SDK.domainSearchSuiteStore.getStore().viewMode;
      const url = urls.getDomainUrl({
        domainName,
        msid,
        referralAdditionalInfo: viewMode || 'domains-gate'
      });
      window.open(url, '_self');
    },
    autoInvoke: props.autoInvoke
  })
};
//# sourceMappingURL=actionStatuses.js.map